
import { HalfPitchGrid, SmallWallDelete, SmallRoomCorrection, PointToPointList, CreatePointData
    , AxisParallelWall, TiltCorrection, StraightLine, CrossWallAddPoint, OverlapWall, StraightLineDeletePoint, DeleteDiagonalWall, SmallAngleRoomDelete, SearchOuterWall, OnGrid } from '../index';
import { PointInfo } from '../../WalltoFittingInfo';
import { BUILDING_TYPE_MANSION, BUILDING_TYPE_HOUSE } from '../../../webcad/Constants';
import { FurnitureType } from '../FurnitureInfo';
import { ThreeView } from '../../../view3d/webcad';

export type ModuleType = {num: number, str: string, select: boolean};
export type CorrectionType = {
    number: number,                                 /** 補正番号 */
    func: (pointList: PointInfo[], floor: number, correctionObject: CorrectionType) => PointInfo[],  /** 補正関数 */
    key: string,                                    /** しきい値のローカルストレージのキー名 */
    defalt: number | null,                          /** デフォルトのしきい値 ない場合はnull */
    min: number,                                    /** しきい値の最小値 */
    max: number,                                    /** しきい値の最大値 */
    option: ModuleType[] | null
}

export class CorrectionManager {

    constructor(private buildingType: number) {}
    
    /** 
     * 管理オブジェクト 
     * */
    public Correction: CorrectionType[] = [
        {
            /** 家の傾き補正 */
            number: 1,
            func: this._TiltCorrection,
            key: 'TiltCorrection',
            defalt: null,
            min: null,
            max: null,
            option: null
        },
        {
            /** 直線化補正 */
            number: 2,
            func: this._StraightLine,
            key: 'StraightLine',
            defalt: 200, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** 壁の歪み補正 */
            number: 3,
            func: this._AxisParallelWall,
            key: 'AxisParallelWall',
            defalt: 100, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** モジュールピッチ補正 戸建て */
            number: 4,
            func: this._PitchGrid,
            key: 'PitchGrid',
            defalt: 1/4, 
            min: 1,
            max: 1000,
            option: [
                {num: 0.5, str: '1/2', select: false},
                {num: 0.25, str: '1/4', select: true}, 
                {num: 0.125, str: '1/8', select: false}
            ]
        },
        {
            /** 短い壁の削除 */
            number: 5,
            func: this._SmallWallDelete,
            key: 'SmallWallDelete',
            defalt: 100, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** 小さい部屋の補正 */
            number: 6,
            func: this._SmallRoomDelete,
            key: 'SmallRoomDelete',
            defalt: 500, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** グリッドに乗せる補正(戸建て) */
            number: 7,
            func: this._OnGrid,
            key: 'OnGrid',
            defalt: null,
            min: null,
            max: null,
            option: null
        },
        {
            /** 外周補完 */
            number: 8,
            func: this._CreateOuterWall,
            key: 'CreateOuterWall',
            defalt: null,
            min: null,
            max: null,
            option: null
        },
        {
            /** 交わる壁の頂点の追加 */
            number: 9,
            func: this._CrossWallAddPoint,
            key: 'CrossWallAddPoint',
            defalt: 200, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** 重なっている独立壁を削除する */
            number: 10,
            func: this._OverlapWall,
            key: 'OverlapWall',
            defalt: 200, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** 軸平行でない独立壁の削除 */
            number: 11,
            func: this._DeleteDiagonalWall,
            key: 'DeleteDiagonalWall',
            defalt: 10, // 度単位 何度まで許容するか
            min: 0,
            max: 85,
            option: null
        },
        {
            /** 直線状の点の結合 */
            number: 12,
            func: this._StraightLineDeletePoint,
            key: 'StraightLineDeletePoint',
            defalt: 200, // mm単位
            min: 0,
            max: 1000,
            option: null
        },
        {
            /** なす角が小さい部屋の削除 */
            number: 13,
            func: this._SmallAngleRoomDelete,
            key: 'SmallAngleRoomDelete',
            defalt: 30, // 度単位 何度以内を削除するか
            min: 0,
            max: 85,
            option: null
        },
        {
            /** モジュールピッチ補正 マンション */
            number: 14,
            func: this._PitchGrid,
            key: 'PitchGrid_MANSION',
            defalt: 1/5, 
            min: 1,
            max: 1000,
            option: [
                {num: 0.5, str: '1/2', select: false},
                {num: 0.25, str: '1/4', select: false},
                {num: 0.2, str: '1/5', select: true},
                {num: 0.1, str: '1/10', select: false}
            ]
        },
    ]
    
    /** 
     * ローカルストレージに保存 
     * */
    public saveLocalStrage(key: string, value: number): void {
        localStorage.setItem(key, String(value));
    }
    
    /** 
     * ローカルストレージから取得 
     * */
    public getLocalStrage(key: string): string | null {
        return localStorage.getItem(key);
    }
    
    /** 
     * しきい値設定 
     * */
    static setThreshold(_class, key: string, defalt: number): void {
        if (_class.length == null) return;
        const value = localStorage.getItem(key);
        if (value == null) _class.length(defalt);
        else _class.length(Number(value));
    }
    
    /** 
     * 家の傾きを補正 
     * */
    protected _TiltCorrection (pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        let radiun: number = 0;
        const tiltCorrection = new TiltCorrection(pointList);
        radiun = tiltCorrection.execute();
        const furnitureInfo = ThreeView.get().LidarManager.furnitureInfo[floor];
        if (furnitureInfo != null && furnitureInfo.length > 0) {
            ThreeView.get().LidarManager.furnitureInfo[floor] = tiltCorrection.furnitureCorrection(furnitureInfo, radiun);
        }
        const pinInfo = ThreeView.get().LidarManager.pinInfo[floor];
        if (pinInfo != null && pinInfo.length > 0) {
            ThreeView.get().LidarManager.pinInfo[floor] = tiltCorrection.pinCorrection(pinInfo, radiun);
        }
        return new PointToPointList(pointList, -radiun).execute();
    }

    /** 
     * 直線化 
     * */
    protected _StraightLine(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const pointData_ = new CreatePointData(pointList);
        pointData_.execute();
        const roomList = pointData_.roomList;
        const straightLine = new StraightLine(pointList, roomList);
        CorrectionManager.setThreshold(straightLine, correctionObject.key, correctionObject.defalt); // しきい値設定
        return straightLine.execute();
    }
    
    /** 
     * 壁の歪み補正 
     * */
    protected _AxisParallelWall(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const axisParallelWall = new AxisParallelWall(pointList); 
        CorrectionManager.setThreshold(axisParallelWall, correctionObject.key, correctionObject.defalt); // しきい値設定
        return axisParallelWall.execute();
    }

    /** 
     * モジュールピッチ補正 
     * */
    protected _PitchGrid(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const halfPitchGrid = new HalfPitchGrid(pointList);
        CorrectionManager.setThreshold(halfPitchGrid, correctionObject.key, correctionObject.defalt); // しきい値設定
        return halfPitchGrid.execute();
    }

    /** 
     * 短い壁の削除 
     * */
    protected _SmallWallDelete(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const smallWallDelete = new SmallWallDelete(pointList);
        CorrectionManager.setThreshold(smallWallDelete, correctionObject.key, correctionObject.defalt); // しきい値設定
        return smallWallDelete.execute();
    }

    /** 
     * 小さい部屋の削除 
     * */
    protected _SmallRoomDelete(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const pointData = new CreatePointData(pointList);
        pointData.execute();
        const roomList = pointData.roomList;
        const smallRoomCorrection = new SmallRoomCorrection(pointList);
        CorrectionManager.setThreshold(smallRoomCorrection, correctionObject.key, correctionObject.defalt); // しきい値設定

        for (let i = 0; i< roomList.length; i++) {
            const room = roomList[i];
            pointList = smallRoomCorrection.execute(room);
        }

        return pointList;
    }

    /** 
     * 外周補正 
     * */
    protected _CreateOuterWall(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const searchOuterWall = new SearchOuterWall(pointList);
        return searchOuterWall.execute();
    }

    /** 
     * グリッドに乗せる補正(戸建て) 
     * */
    protected _OnGrid(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        if (this.buildingType == BUILDING_TYPE_MANSION) return pointList; // マンションの時は吸着ポイントなし
        return new OnGrid(pointList).execute();
    }

    /** 
     * 交わる壁の頂点の追加
     * */
    protected _CrossWallAddPoint(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const crossWallAddPoint = new CrossWallAddPoint(pointList);
        CorrectionManager.setThreshold(crossWallAddPoint, correctionObject.key, correctionObject.defalt); // しきい値設定
        return new CrossWallAddPoint(pointList).execute();
    }

    /** 
     * 重なっている壁の削除
     * */
    protected _OverlapWall(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const overlapWall = new OverlapWall(pointList);
        CorrectionManager.setThreshold(overlapWall, correctionObject.key, correctionObject.defalt); // しきい値設定
        return overlapWall.execute();
    }

    /** 
     * 軸平行でない独立壁の削除
     * */
    protected _DeleteDiagonalWall(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const deleteDiagonalWall = new DeleteDiagonalWall(pointList);
        CorrectionManager.setThreshold(deleteDiagonalWall, correctionObject.key, correctionObject.defalt); // しきい値設定
        return deleteDiagonalWall.execute();
    }
    
    /** 
     * 直線状の点の結合 
     * */
    protected _StraightLineDeletePoint(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const straightLineDeletePoint = new StraightLineDeletePoint(pointList);
        CorrectionManager.setThreshold(straightLineDeletePoint, correctionObject.key, correctionObject.defalt); // しきい値設定
        return straightLineDeletePoint.execute();
    }

    /** 
     * なす角が小さい部屋の削除
     * */
    protected _SmallAngleRoomDelete(pointList: PointInfo[], floor: number, correctionObject: CorrectionType): PointInfo[] {
        const smallAngleRoomDelete = new SmallAngleRoomDelete(pointList);
        CorrectionManager.setThreshold(smallAngleRoomDelete, correctionObject.key, correctionObject.defalt); // しきい値設定
        return smallAngleRoomDelete.execute();
    }

}